import { type BottomTabHeaderProps } from '@react-navigation/bottom-tabs'
import { getHeaderTitle, Header as RNEHeader } from '@react-navigation/elements'
import { type StackHeaderProps } from '@react-navigation/stack'
import { useSafeAreaInsets } from 'react-native-safe-area-context'

import { HeaderBackButton, HeaderTitle } from '@/components'
import { COLOR_BRAND_BLUE_400, COLOR_BRAND_PURPLE_500, COLOR_WHITE, getRGBA, HEADER_HEIGHT } from '@/lib'

export const Header = ({
  back,
  options,
  route
}: (BottomTabHeaderProps | StackHeaderProps) & {
  back?: {
    title: string | undefined
    href: string | undefined
  }
}) => {
  const insets = useSafeAreaInsets()
  const title = getHeaderTitle(options, route.name)

  return (
    <RNEHeader
      {...options}
      back={back}
      headerBackButtonDisplayMode='minimal'
      headerLeft={
        // no header left given
        typeof options.headerLeft !== 'function'
          ? // and we can go back
            back
            ? (props) => <HeaderBackButton {...props} />
            : undefined
          : // otherwise use whatever header left given
            options.headerLeft
      }
      headerShadowVisible={false}
      headerStyle={{
        backgroundColor: COLOR_BRAND_BLUE_400,
        borderBottomWidth: 0.5,
        borderBottomColor: getRGBA(COLOR_BRAND_PURPLE_500, 0.4),
        height: HEADER_HEIGHT + insets.top
      }}
      headerTintColor={COLOR_WHITE}
      headerTitle={
        typeof options.headerTitle !== 'function' ? () => <HeaderTitle title={title} /> : options.headerTitle
      }
      headerTitleAlign='left'
      headerTitleStyle={{
        fontFamily: 'Poppins_700Bold',
        fontSize: 20,
        lineHeight: 28
      }}
      title={title}
    />
  )
}
